import { Component, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}
interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: { componentStack?: string | null }): void {
    console.error('ErrorBoundary caught', error, info);
  }

  render(): ReactNode {
    if (this.state.error) {
      return (
        <div className="min-h-screen bg-slate-50 flex items-center justify-center p-6">
          <div className="max-w-lg w-full bg-white border border-red-200 rounded-xl p-6 shadow-lg">
            <h1 className="text-lg font-bold text-red-700 mb-2">Erreur de l&apos;application</h1>
            <p className="text-sm text-slate-600 mb-3">
              L&apos;outil de soumission n&apos;a pas pu charger. Détails techniques :
            </p>
            <pre className="bg-slate-100 p-3 rounded-md text-xs text-slate-800 overflow-x-auto whitespace-pre-wrap break-words">
              {this.state.error.message}
              {'\n\n'}
              {this.state.error.stack?.split('\n').slice(0, 8).join('\n')}
            </pre>
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="mt-4 w-full bg-blue-500 text-white py-3 rounded-xl font-bold"
            >
              Recharger
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
